import { render, staticRenderFns } from "./CompanyUserCard.vue?vue&type=template&id=73d1c836&"
import script from "./CompanyUserCard.vue?vue&type=script&lang=js&"
export * from "./CompanyUserCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports